import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReviewPopupKYC from './review-popup';
import DocumentPreview from '../Create-Investment/documentpreview';
import ActivityLog from '../../Components/ActivityLog/activity-log';
import StatusButton from '../../Components/Onbaording/status-button';
import SectionStatusGrid from '../../Components/Onbaording/status-section';
// import StatusDropdown from "../../Components/Onbaording/section-status-dropdown";
import FileUploadDisplay from '../../Components/Onbaording/file-display';
import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';
import AuditStepper from '../../Components/Onbaording/onboarding-stepper';

// const steps = [
//   {
//     key: 'submitted',
//     label: 'Application Submitted',
//     icon: 'description',
//     status: 'completed',
//   },
//   // {
//   //   key: 'sanction',
//   //   label: 'Sanction Verified',
//   //   icon: 'gavel',
//   //   status: 'completed',
//   // },
//   {
//     key: 'identity',
//     label: 'Identity Verified',
//     icon: 'verified_user',
//     status: 'completed',
//   },
//   {
//     key: 'manual',
//     label: 'Manual Review',
//     icon: 'manage_search',
//     status: 'active',
//   },
//   {
//     key: 'approved',
//     label: 'Approved',
//     icon: 'check_circle',
//     status: 'pending',
//   },
// ];
const ReviewKycAgent = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dropdownRef = useRef();
  const { customerId } = useParams();
  const navigate = useNavigate();
  const updateFieldStatus = useSelector(
    (state) => state.form.updateFieldStatus,
  );
  const [steps, setSteps] = useState([]);
  const [countryCode, setCountryCode] = useState(null);
  const [stateId, setStateId] = useState(null);
  const { showToast } = useToast();
  const [showPopup, setShowPopup] = useState(false);
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [middleName, setMiddleName] = useState(null);
  const [nameFromBirth, setNameFromBirth] = useState('');
  const [dob, setDob] = useState(null);
  const [formattedDOB, setFormattedDOB] = useState('');
  const [formerNames, setFormerNames] = useState(null);
  const [redAddress, setRedAddress] = useState(null);
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [documentNumber, setDocumentNumber] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const [isOpenAction, setIsOpenAction] = useState(false);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/agency/agents/review/${customerId}/verifications`,
      );

      if (response.status == 200) {
        //Personal info
        setFirstName(response.data.agent_details.first_name);
        setApplicantCountry(response.data.agent_details.applicant_country);
        setLastName(response.data.agent_details.last_name);
        setMiddleName(response.data.agent_details.middle_name);
        setNameFromBirth(response.data.agent_details.gender);
        setFormerNames(response.data.agent_details.former_names);
        const date = new Date(response.data.agent_details.dob.value);
        const formattedDate = date.toLocaleDateString('en-GB');
        setDob(response.data.agent_details.dob);
        setFormattedDOB(formattedDate);
        setRedAddress(response.data.agent_details.address);
        setExpiryDate(response.data.driving_licence.document_expiry);
        setDocumentNumber(response.data.driving_licence.document_number);
        setFileDriverLinsenceFront(response.data.driving_licence.front_file);
        setFileDriverLinsenceBack(response.data.driving_licence.back_file);
        setCountryCode(response.data.driving_licence.country_of_issue);
        setStateId(response.data.driving_licence.state_of_issue);
        setIsDataAvailable(true);
      }
    } catch (err) {
      setIsDataAvailable(false);
      showToast(err.message, 'error');
    }
  };
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        `/api/v1/agency/agents/review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data.sections);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const getOverallJourney = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/agency/agents/review/${customerId}/overall-status`,
      );
      const stageIconMap = {
        application_submitted: 'description',
        sanction_verification: 'gavel',
        identity_verification: 'verified_user',
        manual_review: 'manage_search',
        approved: 'check_circle',
        rejected: 'cancel',
        resubmission: 'refresh',
      };
      if (response.status == 200) {
        const stages = response.data?.stages || [];

        const mappedStages = stages.map((item) => ({
          ...item,
          key: item.stage,
          icon: stageIconMap[item.stage] || 'circle',
        }));

        setSteps(mappedStages);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  const updateApplication = async (action) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      action == 'approve'
        ? `${BASE_URL}/api/v1/agency/agents/review/${customerId}/approve`
        : action == 'resubmit'
          ? `${BASE_URL}/api/v1/agency/agents/review/${customerId}/send-for-resubmission`
          : `${BASE_URL}/api/v1/agency/agents/review/${customerId}/reject`;

    const bodyData = {
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };

          navigate('/team-member-list');
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );

  // const updateSection = async (action, sectionId) => {
  //   const token = localStorage.getItem("jwtToken");
  //   const headers = {
  //     "Content-Type": "application/json",
  //   };

  //   if (token) {
  //     headers.Authorization = `Bearer ${token}`;
  //   }
  //   const apiUrl = `${BASE_URL}/api/v1/agency/agents/review/${customerId}/complete-section`;
  //   const bodyData = {
  //     section_id: sectionId,
  //     action: action,
  //     user_id: customerId,
  //   };
  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: "PUT",
  //       headers: headers,
  //       body: JSON.stringify(bodyData),
  //     });

  //     if (!response.ok) {
  //       if (response.status === 401) {
  //         localStorage.removeItem("jwtToken");
  //         navigate("/login");
  //         throw new Error("Session expired. Please log in again.");
  //       }
  //       const errorData = await response.json().catch(() => ({
  //         message: "An unexpected error occurred",
  //       }));

  //       throw new Error(errorData.message || "Something went wrong");
  //     }

  //     return await response.json();
  //   } catch (error) {
  //     throw new Error(error.message || "Network error, please try again later");
  //   }
  // };
  // const handleUpdateSection = useCallback(
  //   debounce(async (action, sectionId) => {
  //     let toastMessage = null;
  //     try {
  //       const response = await updateSection(action, sectionId);
  //       if (response.status == 200) {
  //         toastMessage = {
  //           message: response.message,
  //           type: "success",
  //         };
  //         getStatus();
  //               getAllDetails();
  //       } else {
  //         toastMessage = { message: response.message, type: "error" };
  //       }
  //     } catch (error) {
  //       toastMessage = { message: error.message, type: "error" };
  //     } finally {
  //       setLoadingUpdate(false); // Ensure `loading` is false first
  //       // Show toast after loading is false
  //       if (toastMessage) {
  //         setTimeout(() => {
  //           showToast(toastMessage.message, toastMessage.type);
  //         }, 1000); // Small delay if needed
  //       }
  //     }
  //   }, 1000),
  //   [customerId], // Dependencies
  // );
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenAction(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };

  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
      getOverallJourney();
    }
  }, [customerId, updateFieldStatus]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
              <span className="font-medium lg:text-lg text-sm">Review KYC</span>
            </div>
          </div>

          <div>
            <div className="flex flex-wrap justify-between p-4 items-center mb-4">
              <div className="flex items-center w-full md:w-auto mb-4 md:mb-0">
                <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto">
                  <h1 className="text-md font-medium mr-2">
                    {firstName?.value} {lastName?.value}
                  </h1>
                </div>
              </div>
              <div className="flex space-x-2 w-full md:w-auto">
                <button
                  onClick={() => {
                    setIsActivityLogOpen(true);
                  }}
                  className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
                >
                  <img
                    src="/backward-10-seconds.svg"
                    alt="Add Icon"
                    className="mr-2"
                  />
                  <span className="inline pr-2">Activity Log</span>
                </button>
              </div>
            </div>
            {isActivityLogOpen && (
              <ActivityLog
                onClose={() => setIsActivityLogOpen(false)}
                customerId={customerId}
              />
            )}
            <div className="w-full  p-4">
              <AuditStepper steps={steps} />
              <div className="w-full mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-6 md:px-7 md:py-7 shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
                <SectionStatusGrid sections={statusData} />
              </div>
            </div>
          </div>
          {isDataAvailable && (
            <>
              {showPopup && currentField && (
                <ReviewPopupKYC
                  isOpen={showPopup}
                  currentField={currentField}
                  currentFieldName={currentFieldName}
                  currentFieldValue={currentFieldValue}
                  currentFieldType={currentFieldType}
                  onClose={() => setShowPopup(false)}
                />
              )}
              {/* End  */}
              {/* Personal Information */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rrounded-2xl">
                  <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/profile-circle-black.svg"
                        alt="User Avatar"
                        className="h-6 w-6 mb-2"
                      />
                      <h1 className="text-md font-medium mb-2">
                        {' '}
                        Personal Information
                      </h1>
                    </div>
                    {/* <div className="p-4">
                      <StatusDropdown
                        value={statusData[0].status}
                        onChange={(val) => {
                          setLoadingUpdate(true);
                          handleUpdateSection(val, statusData[0].id);
                        }}
                      />
                    </div> */}
                  </div>
                  {/* Will add popup here */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4 ">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          First Name
                        </label>
                        <StatusButton
                          status={firstName.status}
                          count={firstName.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              firstName,
                              'First Name',
                              firstName.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{firstName.value}</div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Last Name
                        </label>
                        <StatusButton
                          status={lastName.status}
                          count={lastName.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              lastName,
                              'Last Name',
                              lastName.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{lastName.value}</div>

                      {middleName && middleName.value && (
                        <>
                          {' '}
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Middle Name
                            </label>
                            <StatusButton
                              status={middleName.status}
                              count={middleName.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  middleName,
                                  'Middle Name',
                                  middleName.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">{middleName.value}</div>
                        </>
                      )}
                      {formerNames?.value?.length > 0 && (
                        <>
                          <div className="flex mt-2  items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              Customer's Former Name(s)
                            </label>
                            <StatusButton
                              status={formerNames.status}
                              count={formerNames.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  formerNames,
                                  "Customer's Former Name(s)",
                                  formerNames.value,
                                  '',
                                )
                              }
                            />
                          </div>
                          <div className="mt-0 text-sm">
                            {formerNames.value}
                          </div>
                        </>
                      )}
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <div className="flex  items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Gender
                        </label>
                        <StatusButton
                          status={nameFromBirth.status}
                          count={nameFromBirth.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              nameFromBirth,
                              'Gender',
                              nameFromBirth.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="flex items-center gap-4">
                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="birthName"
                            value="male"
                            checked={nameFromBirth.value == 'male'}
                            disabled={true}
                            className="w-4 h-4 text-[#46DA55] border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Male</span>
                        </label>

                        <label className="flex items-center text-sm text-black">
                          <input
                            type="radio"
                            name="birthName"
                            value="female"
                            disabled={true}
                            checked={nameFromBirth.value == 'female'}
                            className="w-4 h-4  border-gray-300 focus:ring-[#46DA55]"
                          />
                          <span className="ml-2">Female</span>
                        </label>
                      </div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Date of Birth
                        </label>
                        <StatusButton
                          status={dob.status}
                          count={dob.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              dob,
                              'Date of Birth',
                              formattedDOB,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">{formattedDOB}</div>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col px-4">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Applicant's Country
                        </label>
                        <StatusButton
                          status={applicantCountry.status}
                          count={applicantCountry.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              applicantCountry,
                              "Applicant's Country",
                              applicantCountry.value.name,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">
                        {applicantCountry.value.name}
                      </div>
                      <div className="flex mt-2 items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-[#A6A6A6] flex items-center"
                        >
                          Residential Address
                        </label>
                        <StatusButton
                          status={redAddress.status}
                          count={redAddress.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              redAddress,
                              'Residential Address',
                              redAddress.value.google_address,
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">
                        {redAddress.value.google_address}
                      </div>
                    </div>
                  </div>
                  {/* End  */}
                </div>
              </div>
              {/* End  */}
              {/* Upload Proof Documents */}
              <div className="w-full  p-4">
                <div className="mt-2 border pb-4 pt-2 rounded-2xl">
                  <div className="flex flex-wrap md:flex-nowrap items-center justify-between border-colour-custom pt-2 px-4 gap-4">
                    {/* Left Section (Title + Icon) */}
                    <div className="flex text-black items-center space-x-2">
                      <img
                        src="/note-2.svg"
                        alt="User Avatar"
                        className="h-6 w-6"
                      />
                      <h1 className="text-md font-medium">
                        Upload Proof Documents
                      </h1>
                    </div>
                    {/* Right Section (Button + Edit Icon) */}
                    {/* <div className="p-4">
                      <StatusDropdown
                        value={statusData[1].status}
                        onChange={(val) => {
                          setLoadingUpdate(true);
                          handleUpdateSection(val, statusData[1].id);
                        }}
                      />
                    </div>{" "} */}
                  </div>
                  {/* Extra details */}
                  <div className="grid grid-cols-1 pb-4 pt-2 mx-4 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    <div className="flex flex-col tex-xs ">
                      <FileUploadDisplay
                        label="Upload Copy of Driver's License (Front)"
                        fileData={fileDriverLinsenceFront}
                        onFileClick={handleFileClick}
                      />
                      <div className="mt-2">
                        <FileUploadDisplay
                          label="Upload Copy of Driver's License (Back)"
                          fileData={fileDriverLinsenceBack}
                          onFileClick={handleFileClick}
                        />
                      </div>
                    </div>
                    <div className="flex px-2 flex-col lg:pt-2 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 ">
                      <div className="flex items-center justify-between md:pr-0">
                        <label
                          htmlFor="investmentType"
                          className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                        >
                          Driver's License Number
                        </label>
                        <StatusButton
                          status={documentNumber.status}
                          count={documentNumber.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              documentNumber,
                              "Driver's License Number",
                              documentNumber.value,
                              '',
                            )
                          }
                        />
                      </div>
                      <span>{documentNumber.value}</span>
                      <div className="flex items-center justify-between  md:pr-0">
                        <label
                          htmlFor="investmentType"
                          className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                        >
                          Expiry Date
                        </label>
                        <StatusButton
                          status={expiryDate?.status}
                          count={expiryDate.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              expiryDate,
                              ' Expiry Date',
                              expiryDate
                                ? new Date(expiryDate.value).toLocaleDateString(
                                    'en-GB',
                                  )
                                : '',
                              '',
                            )
                          }
                        />
                      </div>
                      <div className="mt-0 text-sm">
                        {expiryDate
                          ? new Date(expiryDate.value).toLocaleDateString(
                              'en-GB',
                            )
                          : ''}
                      </div>
                    </div>
                    <div className="flex lg:pt-2 pt-0 flex-col">
                      <div className="flex items-center justify-between md:pr-0">
                        <label
                          htmlFor="investmentType"
                          className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                        >
                          Country where issued
                        </label>
                        <StatusButton
                          status={countryCode.status}
                          count={countryCode.comments?.length}
                          openSection={() =>
                            handleStatusClick(
                              countryCode,
                              ' Country where issued',
                              countryCode.value.name,
                              '',
                            )
                          }
                        />
                      </div>
                      <span>{countryCode.value.name}</span>

                      {countryCode.value.id == 14 && (
                        <>
                          <div className="flex mt-2 items-center justify-between md:pr-0">
                            <label
                              htmlFor="investmentType"
                              className="text-sm w-40 md:w-full text-[#A6A6A6] flex items-center whitespace-normal words-break"
                            >
                              State or Territory in Australia
                            </label>
                            <StatusButton
                              status={stateId.status}
                              count={stateId.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  stateId,
                                  'State or Territory in Australia',
                                  stateId?.value?.name,
                                  '',
                                )
                              }
                            />
                          </div>
                          <span>{stateId?.value?.name}</span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* End  */}
              <div className="flex items-center mt-6 p-4 bg-[#375AE7]">
                {/* Right Section: Download Button */}
                <div className="flex items-center justify-end w-full">
                  <div ref={dropdownRef} className="relative inline-block mr-4">
                    {/* Button */}
                    <div
                      className="flex text-sm justify-between items-center py-2 px-2 border border-white  w-40 rounded-full cursor-pointer"
                      onClick={() => setIsOpenAction(!isOpenAction)}
                    >
                      <span className="text-right pl-4 text-white">
                        Actions
                      </span>
                      <span className="text-gray-500">
                        {' '}
                        <img
                          src="/white-dropdown.svg"
                          alt="document-download"
                          className="pr-2"
                        />
                      </span>
                    </div>

                    {/* Dropdown Menu */}
                    {isOpenAction && (
                      <div className="absolute text-xs top-[-250%] right-0 bg-white text-black shadow-lg rounded-md w-40 p-2 z-10">
                        <ul>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'approve');
                            }}
                            className="p-2 hover:bg-[#375AE7] hover:text-white cursor-pointer"
                          >
                            Approve Application
                          </li>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'reject');
                            }}
                            className="p-2 hover:bg-[#375AE7] text-[#FF5050] hover:text-[#FF5050] cursor-pointer"
                          >
                            Reject Application
                          </li>
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, 'resubmit');
                            }}
                            className="p-2 hover:bg-[#375AE7] text-[#FF5050] hover:text-[#FF5050] cursor-pointer"
                          >
                            Send for resubmit
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument.file_name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default ReviewKycAgent;
